"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createQueryStringReducer = exports.queryStringMiddleware = exports.stateToQueryString = void 0;

var _qs = _interopRequireDefault(require("qs"));

var _lodash = _interopRequireDefault(require("lodash.merge"));

var _lodash2 = _interopRequireDefault(require("lodash.get"));

var _lodash3 = _interopRequireDefault(require("lodash.set"));

var _validation = require("./validation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var SERIALIZATION_OPTIONS = {
  allowDots: true,
  arrayFormat: 'repeat'
};

var _pruneNullLeaves = function _pruneNullLeaves(obj) {
  if (!Object.entries(obj).length) {
    return {};
  }

  return Object.assign.apply(Object, _toConsumableArray(Object.entries(obj).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        k = _ref2[0],
        v = _ref2[1];

    if (v === null) {
      return {};
    } else if (Array.isArray(v)) {
      return _defineProperty({}, k, v.filter(function (e) {
        return e !== null;
      }));
    } else if (_typeof(v) === 'object') {
      return _defineProperty({}, k, _pruneNullLeaves(v));
    } else {
      return _defineProperty({}, k, v);
    }
  })));
};

var _applySerialization = function _applySerialization(stateData, map) {
  var result = {};
  Object.entries(map).forEach(function (_ref6) {
    var _ref7 = _slicedToArray(_ref6, 2),
        k = _ref7[0],
        stateField = _ref7[1].stateField;

    result[k] = typeof stateField === 'string' ? (0, _lodash2.default)(stateData, stateField, null) : stateField.serialize(stateData);
  });
  return result;
};

var stateToQueryString = function stateToQueryString(state) {
  for (var _len = arguments.length, maps = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    maps[_key - 1] = arguments[_key];
  }

  var serializedState = Object.assign.apply(Object, _toConsumableArray(maps.map(function (map) {
    return _pruneNullLeaves(_applySerialization(state, map));
  })));
  return _qs.default.stringify(serializedState, SERIALIZATION_OPTIONS);
};

exports.stateToQueryString = stateToQueryString;

var queryStringMiddleware = function queryStringMiddleware(history, _ref8) {
  var reduxPathname = _ref8.reduxPathname,
      routes = _ref8.routes;
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var usePush = config.usePush;
  return function (store) {
    return function (next) {
      return function (action) {
        var result = next(action);
        var state = store.getState();
        var currentPath = reduxPathname(state);
        var pathConfig = routes[currentPath];
        var routesConfig = pathConfig && !Array.isArray(pathConfig) ? [pathConfig] : pathConfig;

        if (routesConfig && routesConfig.length) {
          var prevData = _qs.default.parse(history.location.search.slice(1), {
            allowDots: true
          });

          var dataList = routesConfig.filter(function (_ref9) {
            var listen = _ref9.listen;
            return Array.isArray(listen) ? listen.includes(action.type) : listen === action.type;
          }).map(function (_ref10) {
            var select = _ref10.select,
                serialize = _ref10.serialize;
            var qsState = select(state);

            var data = _pruneNullLeaves(qsState);

            if (serialize) {
              data = _applySerialization(data, serialize);
            }

            return data;
          });

          if (dataList.length) {
            var data = Object.assign.apply(Object, _toConsumableArray(dataList));
            data = _pruneNullLeaves(_objectSpread({}, prevData, data));

            var queryString = _qs.default.stringify(data, SERIALIZATION_OPTIONS);

            var path = "".concat(currentPath, "?").concat(queryString);

            if (usePush) {
              history.push(path);
            } else {
              history.replace(path);
            }
          }
        }

        return result;
      };
    };
  };
};

exports.queryStringMiddleware = queryStringMiddleware;

var createQueryStringReducer = function createQueryStringReducer(config, qsFunc) {
  var resetFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (s) {
    return s;
  };
  return function (state, action) {
    var result = qsFunc(state, action);

    if (!result) {
      return resetFunc(state, null);
    }

    var queryString = result.queryString,
        namespace = result.namespace;

    if (queryString) {
      var values = _qs.default.parse(queryString, {
        allowDots: true
      });

      var newValues = null;

      try {
        newValues = (0, _validation.mapQueryFields)(values, config);
        return (0, _lodash.default)({}, state, namespace ? (0, _lodash3.default)({}, namespace, newValues) : newValues);
      } catch (e) {
        console.warn(e);
        return resetFunc(state, namespace, true);
      }
    }

    return resetFunc(state, namespace);
  };
};

exports.createQueryStringReducer = createQueryStringReducer;